import React, { Fragment } from 'react'
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, FormGroup, Input, Label, Row, Table } from 'reactstrap';
import { useInvoiceSettings } from '../../../hooks/invoice/useInvoiceSettings';
import 'animate.css';
import { ModalInvoiceSettings } from '../../../components/commercialLines/ModalInvoiceSettings';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../configuraciones/commercialLines/StyleInvoiceSettings.css'

export const InvoiceSettings = () => {

    const {
        //MODALS SETTINGS
        modal, modalTitle, method, loading,

        toggle,

        //INVOICE SETTINGS MODELS
        viewFormFilters,listInvoiceSettings,
        filterTypeDocument,
        id_type_document, code, serie, initial_folio, final_folio, is_default, is_fiscal, validationInvoiceSettings,
        listTypeDocuments,

        //INVOICE SETTINGS METHODS
        handleInputChange, handleChangeFilterTypeDocument,
        handleViewFilters, 
        handleAddInvoiceSettings, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete, closeDialog,
        closeDeleteAlert, modalAlert, showDeleteAlert, handleClearInvoiceSettings, searchInvoiceSettings,
        handleSearchInvoiceSettings, loadingExport, handleExcelInvoiceSettings
    } = useInvoiceSettings();
    

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_invoice_settings)}
                    title="Editar sucursal"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>

                <button
                    onClick={() => handleDelete(rowData.id_invoice_settings)}
                    title="Estudios a maquilar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#db1717"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>

               
            </div>
        );
    };

    const typeDocumentFilterTemplate = (options) => {

        return (
            <div className='containerFilterDocuments'>

                <label className='labelFilterDocuments'>
                    Tipo de documento
                </label>

                <Input
                    type='select'
                    value={options.value || ''}
                    onChange={(e) => {
                        options.filterApplyCallback(e.target.value);
                    }}
                    className='selectFilterDocuments'
                >
                    <option value="">
                        Todos los documentos
                    </option>

                    {
                        listTypeDocuments.length > 0 &&
                        listTypeDocuments.map(obj => (
                            <option
                                key={obj.id_type_document}
                                value={obj.name_type_document || obj.name}
                            >
                                {obj.name}
                            </option>
                        ))
                    }
                </Input>

                {/* BOTÓN PERSONALIZADO */}
                <button
                    type="button"
                    className="btnClearCustomFilter"
                    onClick={() => {
                        options.filterApplyCallback('');
                    }}
                >
                    Limpiar filtros
                </button>

            </div>
        );
    };

    return (
        <Fragment>
            <Container fluid={true} style={{  scrollBehavior: "smooth" , transform: "scale(0.8)",    width: "125%",    transformOrigin: "top left" }}>
                <Row>
                    <Col className={ !viewFormFilters ? "animate__animated animate__slideOutLeft d-none" : "default-according style-1 faq-accordion job-accordion position-relative animate__animated animate__slideInLeft" } sm="12" md="3" lg="3"  >
                        <Row className='position-sticky'>
                            <Col sm="12" md="12" lg="12">
                                <Card>
                                    <CardHeader className='bg-primary'>
                                        <h5 className='mb-0'>
                                            <Button color='link pl-0' data-toggle="collapse" data-target="#collapseicon" aria-expanded={true} aria-controls="collapseicon">
                                                Filtros de búsqueda
                                            </Button>
                                        </h5>
                                    </CardHeader>
                                    <Collapse isOpen={true}>
                                        <CardBody className='p-3'>
                                            <Row>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Tipo de documento</Label>
                                                        <Input type='select' onChange={handleChangeFilterTypeDocument} value={filterTypeDocument}>
                                                            <option>Selecciona una opción</option>
                                                            {
                                                                listTypeDocuments.length > 0 && listTypeDocuments.map(obj => {
                                                                    return <option value={obj.id_type_document} selected={ obj.id_type_document === filterTypeDocument }>{ obj.name }</option>
                                                                })
                                                            }
                                                        </Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            {/* ::TODO DESCOMENTAR CUANDO YA ESTEN LOS ESTATUS PARA SERIE Y FOLIO */}
                                            {/* <Row className='mt-2'>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Estatus</Label>
                                                        <Input type='select'>
                                                            <option>Selecciona una opción</option>
                                                        </Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row> */}
                                            <Row className='mt-1'>
                                                <Col sm="12">
                                                    <Button outline color='primary' size='sm' className='text-center'>
                                                        Filtrar
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Collapse>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm="12" md={!viewFormFilters ? "12" : "9"} lg={ !viewFormFilters ? "12" : "9" } >
                        <Card>
                            <CardBody className='p-1'>
{/*                           
                                <div className='text-right' style={{ margin: 5, paddingBottom: 10 }}>
                                    <Button className='btn btn-pill btn-air-success' color='info' size='sm' onClick={handleViewFilters}>
                                        <i className="icofont icofont-filter"></i> Filtros
                                    </Button>
                                                                  
                                </div> */}
                    
                                <TitleDataTable
                                    titleTable="Serie y folio para facturas"
                                    buttonActions={handleExcelInvoiceSettings}
                                    titleButton="Listado de serie y folio para facturas"
                                    isDisbled={loadingExport}
                                    loadingIsDisabled={loadingExport}
                                    titleCreate="Crear sitio"
                                    buttonActionsCreate={handleAddInvoiceSettings}
                                    actionInput={handleSearchInvoiceSettings}
                                    valueFilter={searchInvoiceSettings}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearInvoiceSettings}
                                />


                                <div className="invoiceSettingsFilterCustom">
                                    <DataTable
                                        value={listInvoiceSettings}
                                        paginator
                                        rows={15}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[15, 50, 100]} 
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        filterDisplay="menu"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >
            
                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column 
                                            field="name_branch"
                                            header="Sucursal" 
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.name_branch}
                                                </span>
                                            )}
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />

                                        <Column
                                            field="name_type_document"
                                            header="Tipo de documento"
                                            filter
                                            filterElement={typeDocumentFilterTemplate}
                                            showFilterMatchModes={false}
                                            showFilterOperator={false}
                                            showAddButton={false}
                                            showApplyButton={false}
                                            showClearButton={false}
                                            filterMenuClassName="customFilterMenu"
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                            body={(rowData) => (
                                                <span>
                                                    {rowData.name_type_document}
                                                </span>
                                            )}
                                        />
                                        <Column 
                                            field="code" 
                                            header="Código" 
                                            headerStyle={headerStyle} 
                                            style={cellStyle}
                                            body={(rowData) => (
                                                <span>
                                                    {rowData.code}
                                                </span>
                                            )}
                                        />
                                        <Column 
                                            field="serie" 
                                            header="Serie" 
                                            headerStyle={headerStyle} 
                                            style={cellStyle}
                                            body={(rowData) => (
                                                <span>
                                                    {rowData.serie}
                                                </span>
                                            )}
                                        />

                                        <Column 
                                            field="initial_folio"
                                            header="Folio" 
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.initial_folio}
                                                </span>
                                            )}
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />

                                        <Column 
                                            field="final_folio"
                                            header="Siguiente folio" 
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.final_folio}
                                                </span>
                                            )}
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />
                                        <Column 
                                            field="is_default" 
                                            header="Preferida"
                                            body={(rowData) => { 

                                                const id_defaults = rowData.is_default === true || rowData.is_default === 1;

                                                return (
                                                    <span
                                                        style={{
                                                            width: "50px",          
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            backgroundColor: id_defaults ? "#2ecc71" : "#e74c3c",
                                                            padding: "4px 0px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {id_defaults ? "Sí" : "No"}
                                                    </span>
                                                );
                                            }} 
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />

                                        <Column 
                                            field="is_fiscal" 
                                            header="Preferida"
                                            body={(rowData) => { 

                                                const is_fiscal = rowData.is_fiscal === true || rowData.is_fiscal === 1;

                                                return (
                                                    <span
                                                        style={{
                                                            width: "50px",          
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            backgroundColor: is_fiscal ? "#2ecc71" : "#e74c3c",
                                                            padding: "4px 0px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {is_fiscal ? "Sí" : "No"}
                                                    </span>
                                                );
                                            }} 
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />

                                       
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                            </CardBody>
                        </Card>
                         {showDeleteAlert && (
                            <AlertDataTable
                                titleAlert="Eliminar tipo de muestra"
                                visibleAlert={modalAlert}
                                onHideAlert={closeDeleteAlert}
                                sizeAlert="medium-dialog delete-method"
                                messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el tipo de muestra?"
                                alert1={true}
                                titleAlert1={code}
                                buttonAcept
                                titleNotLoading="Eliminar"
                                titleDanger="Cancelar"
                                actionAcept={saveDelete}
                            />
                        )}
                    </Col>                    
                </Row>
            </Container>
            <ModalInvoiceSettings
                {
                    ...{
                        modal, modalTitle, method, closeDialog, loading,
                        id_type_document, code, serie, initial_folio, final_folio, is_default, is_fiscal, validationInvoiceSettings,
                        listTypeDocuments,
                        handleInputChange, saveCreate, saveUpdate, saveDelete,
                        
                    }
                }
            />
        </Fragment>
    )
}
